import React, { useRef, useState } from 'react';
import { PlayIcon } from '../../components/icons';
import { trackEvent } from '../../analytics';
import poster from '../../media/trailer-poster.jpg';

// Cache-bust when the trailer file is replaced under the same name. The deploy
// script serves media with a one-year immutable cache, so bumping this is the
// only thing that gets a new encode to anyone who already watched the old one.
const TRAILER_SRC = `${process.env.PUBLIC_URL}/media/warm-trailer.mp4?v=20260817`;

/**
 * Click to play. The video is never fetched until someone asks for it, which
 * keeps the landing page light on mobile data.
 */
export default function Trailer() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const play = () => {
    setIsPlaying(true);
    trackEvent('trailer_play');
    // The <video> only gains controls once it is playing, so start it next tick.
    window.requestAnimationFrame(() => videoRef.current?.play());
  };

  return (
    <div className={`trailer${isPlaying ? ' is-playing' : ''}`}>
      <video
        ref={videoRef}
        className="trailer__video"
        src={TRAILER_SRC}
        poster={poster}
        preload="none"
        controls={isPlaying}
        playsInline
        onEnded={() => setIsPlaying(false)}
      />

      {!isPlaying && (
        <button type="button" className="trailer__play" onClick={play}>
          <span className="trailer__play-ring">
            <PlayIcon size={26} />
          </span>
          <span className="trailer__play-label">Play the trailer</span>
          <span className="trailer__play-meta">30 seconds</span>
        </button>
      )}
    </div>
  );
}
